import Application from "../../Application";
import GetRequestTypesInteractor from "./GetRequestTypesInteractor";
import RequestTypesPresenter, {
  IRequestTypesPresenter
} from "../../presenter/request/RequestTypesPresenter";

export default class ShowRequestTypesInteractor {
  private application: Application;
  private getRequestTypes: GetRequestTypesInteractor;
  private output?: IRequestTypesPresenter;

  constructor(application, getRequestTypes) {
    this.application = application;
    this.getRequestTypes = getRequestTypes;
  }

  execute() {
    this.output = RequestTypesPresenter({
      application: this.application,
      initialState: {
        requestTypes: []
      }
    });

    this.getRequestTypes.execute().then(this.output.setRequestTypes);

    return this.output;
  }
}
